// ---------------------------------------------------------------------------
// NAV-3 — Adressen der Projektliste: EIN Bauplan fuer ?phase= / ?sort= / ?owner=.
// ---------------------------------------------------------------------------
// Wer von aussen auf eine bestimmte Sicht der Liste zeigt (Startseite,
// Redirect der aufgeloesten /pipeline-Seite, Hilfe), baut die Adresse hier —
// nicht als Text-Literal. Die Parameter-Namen stehen damit an genau einer
// Stelle; die Seite liest sie in ProjectsListPage.

import type { PipelinePhase } from "@shared/projects/pipelinePhase";

import type { ProjectsListOwnerFilter } from "./projectsListFilterState";
import {
  PROJECTS_LIST_SORT_PARAMS,
  type ProjectsListSortKey,
} from "./projectsListSortState";

export interface ProjectsListHrefParams {
  readonly phase?: PipelinePhase;
  readonly sort?: ProjectsListSortKey;
  readonly owner?: ProjectsListOwnerFilter;
}

export function projectsListHref(params: ProjectsListHrefParams): string {
  const qs = new URLSearchParams();
  if (params.phase !== undefined) qs.set("phase", params.phase);
  if (params.sort !== undefined) {
    qs.set("sort", PROJECTS_LIST_SORT_PARAMS[params.sort]);
  }
  if (params.owner !== undefined) qs.set("owner", params.owner);
  const s = qs.toString();
  return s.length > 0 ? `/projekte?${s}` : "/projekte";
}

/**
 * Die Firmensicht «laengster Stillstand zuerst» im Reiter Verkauf — das Ziel
 * des Stillstand-Waechters und des Kopf-Links im Pipeline-Kurzblick der
 * CEO-Startseite, und der Nachfolger der /pipeline-Seite. `owner=all` steht
 * bewusst drin: die Zahl der Startseite («N Projekte ueber 30 Tage ohne
 * Bewegung») ist firmenweit, und eine gespeicherte «Nur meine»-Wahl darf den
 * Link nicht in eine Teilmenge umlenken.
 */
export const STILLSTAND_LIST_HREF = projectsListHref({
  phase: "verkauf",
  sort: "stillstand_desc",
  owner: "all",
});
